import { Grid, Text } from '@approvalmax/ui/src/components';
import { FC } from 'react';

import { CardLogoProps } from './CardLogo.types';

export const CardLogo: FC<CardLogoProps> = (props) => {
    const { title, logo: Logo } = props;

    return (
        <Grid gap={8} gridTemplateColumns='auto 1fr' alignItems='center'>
            <Logo width={32} height={32} />

            <Text font='label' fontSize='large'>
                {title}
            </Text>
        </Grid>
    );
};
